import React from 'react';
import { Alert } from 'react-bootstrap';
import { useOnlineState } from 'beautiful-react-hooks';

const OfflineNotification: React.FC = () => {
  const isOnline = useOnlineState();

  if (isOnline) return null;

  return (
    <Alert className="m-3" variant="danger">
      <Alert.Heading>Unable to contact to the internet</Alert.Heading>
      <p>Please check network cables, modem and router</p>
    </Alert>
  );
};

export default OfflineNotification;
